import React from 'react';
import { Form, Button, Row, Col, Card, ListGroup, Accordion, Table } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { IconExclamationCircleWarning } from '@components/awpIcons';
import { isValueEmpty, toStringOrEmpty } from '@awp/helpers/utilsReact';
import PropTypes from 'prop-types';
import { selectTextDescription } from '@stores/dataVisualizationSlice';

const row1Style = {
  borderBottom: '1px solid #bdc5cc',
  paddingTop: '4px',
  paddingBottom: '4px',
};

const row2Style = {
  borderLeft: '1px solid #bdc5cc',
  borderBottom: '1px solid #bdc5cc',
  paddingTop: '4px',
  paddingBottom: '4px',
};

const ForecastTimeDays = ({ hasForecast }) => {
  const textDescription = useSelector(selectTextDescription);

  const transposeTable = () => {
    if (
      isValueEmpty(textDescription) ||
      !textDescription.WeatherTextForecastTimeDays ||
      textDescription.WeatherTextForecastTimeDays.length === 0
    )
      return;
    let _textDescription = { ...textDescription };
    const _cntWfs =
      _textDescription.WeatherTextForecastTimeDays.length === 0
        ? 1
        : _textDescription.WeatherTextForecastTimeDays.length;
    let calCols = (12 / _cntWfs) | 0;
    const cols = calCols === 0 ? 1 : calCols;
    let transTextDescription = Object.assign(
      ...Object.keys(_textDescription.WeatherTextForecastTimeDays[0]).map((key) => ({
        [key]: _textDescription.WeatherTextForecastTimeDays.map((o) => o[key]),
      })),
    );

    return (
      <Col md={12} style={{ border: '1px solid #5475a7' }}>
        <Row className="bg-primary font-weight-bold text-white">
          {Object.keys(transTextDescription.TimeDay).map((i) => {
            return (
              <Col key={`timeday-day-${i}`} md={cols} style={{ marginTop: '8px', marginBottom: '8px' }}>
                {transTextDescription.TimeDay[i]}
              </Col>
            );
          })}
        </Row>
        <Row style={{ fontSize: '80%' }}>
          {Object.keys(transTextDescription.TimeDayForecast).map((i) => {
            return (
              <Col key={`timeday-day-fc-${i}`} md={cols} style={i === '0' ? row1Style : row2Style}>
                {i === '0' && _cntWfs > 3 ? (
                  <>
                    <b>{'Afternoon:'}</b>
                    <br />
                  </>
                ) : (
                  <>
                    <b>{'Day:'}</b>
                    <br />
                  </>
                )}
                {transTextDescription.TimeDayForecast[i]}
              </Col>
            );
          })}
        </Row>
        <Row style={{ fontSize: '80%' }}>
          {Object.keys(transTextDescription.TimeDayNightForecast).map((i) => {
            return (
              <Col key={`timeday-night-fc-${i}`} md={cols} style={i === '0' ? row1Style : row2Style}>
                <b>{'Night:'}</b>
                <br />
                {transTextDescription.TimeDayNightForecast[i]}
              </Col>
            );
          })}
        </Row>
      </Col>
    );
  };

  return (
    <React.Fragment>
      <Card style={{ border: 'none' }}>
        <Card.Body className="bg-light" style={{ padding: '0px 0px 1px 0px' }}>
          {!isValueEmpty(textDescription) &&
          textDescription.WeatherTextForecastTimeDays &&
          textDescription.WeatherTextForecastTimeDays.length > 0
            ? transposeTable()
            : !hasForecast && (
                <Col md={12} style={{ padding: '12px', border: '1px solid #ffc107', backgroundColor: '#fff3cd' }}>
                  <IconExclamationCircleWarning style={{ paddingBottom: '4px', paddingRight: '4px' }} />
                  {'No forecast available for the selected date/time range'}
                </Col>
              )}
        </Card.Body>
      </Card>
      <Row style={{ height: '10px' }}></Row>
    </React.Fragment>
  );
};

ForecastTimeDays.propTypes = {
  hasForecast: PropTypes.bool,
};
export default ForecastTimeDays;
